<template>
  <div class="modal-container">
    <div class="modal">
      <div class="modal-header">
        <div class="modal-title">{{ title }}</div>
        <a @click="onCloseClicked" class="close-link"></a>
      </div>
      <div class="modal-body">
        <slot> </slot>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceManager from "../services/service-manager";

export default {
  name: "Modal",
  props: ["width", "title"],
  components: {},
  data() {
    return {
      labels: ServiceManager.getService(this, "Labels"),
      isVisible: this.visible || false,
    };
  },
  mounted() {
    if (window.preventScroll) {
      window.preventScroll(true);
    }
  },
  beforeUnmount() {
    if (window.preventScroll) {
      window.preventScroll(false);
    }
  },
  methods: {
    onCloseClicked() {
      this.$emit("close");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  border: 1px solid #888;
  box-sizing: border-box;
  box-shadow: 5px 5px 15px -2px #000000;
  padding: 20px 20px 10px 20px;
  max-width: 100%;
  max-height: 90%;
  overflow-y: auto;
  width: 1160px;
}

.modal .modal-title {
  font-size: 20px;
  font-weight: 700;
  padding-bottom: 10px;
  text-transform: uppercase;
  text-align: left;
}

.modal .modal-body {
  padding: 10px 0;
  min-height: 430px;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #999;
}

.close-link {
  width: 28px;
  height: 24px;
  background-size: 24px;
  background-repeat: no-repeat;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAA/NJREFUaAXtmU2OEzEQhQOCDWKPYMvcgIOwGbGAY3CBjJirgDRILDhBTsBuNkisQcMSZocE1NfktSrVZTvuJANIKclTdv28V3a7u52exaIgt5z9l+uPdhlHLY8MjNUfADRAP8OpDLxy0vd2xlP5aSYyaGfeLePF2jn4vq0HMg5cIhkGDkL2xek6Kwa42D/d16a+W3s58TiDCitp2EZ5Yz0fiIPikWgfjFDL4QOLCThYOCVlmpi/JI+N96O1VcY/XiFz0mczZDLGjR2LYqI1GWJvryMU/MLGd12WB3zl7BvLecccNMTvPIEODga+YSTJ24YElUSAhDJ0tX158g/62v6C8MOaL8OzPCDST2qgxFiQjVUixif7nK8Vn4/7R/tLqyteijhmge/31M9aRZBtx+9aRMsE/HliEyFbgq2hsbSZpnJiJgV4rW3u95Q2Jih+3/m8CQP3vA+IfREpsQSsPMWNelUh8BWLyM9IoF6PwL7jA+h74FhxjejSg/o+2y2S9I6vPGCpz3brBSb+XgmwZj+vkLEUw1OqBnD07WUFOEysrHGm4YbkfMMLeSdhy+pVVNtRyzksZ5ZUA40+TgylN9aEf+49AGmT5LSz8mwmk4q9ISbEY0D0Z++KpQf0/eyOlf+tdSK4HnYZifI2dARgXHqaChyd5aVbOAvMSFrg5HBqn0iJIJKQWKpcGNyME5GzpFU5ifHlE3P4oTSRGOTHApcmuUaymqCbwQP6vkDR2EsX3uekv8F4efgg+hFc/haJpU6FN5MApPmFq8plkxZJPHjxgCzKlXkEMFc3z6lzgcnjKdwUTgZzSJoH38jcs1w8hWcJFz7bXZrhxo/DWQzHpOMKHHgF2MRs1NpG1oaOmhxyb/xszi3bc4vHwktjMME+iPDw2+U4WSq6ZIdr1k+xbPa9h+xSUXPsW71asqKx8dI7xFbpnQg1NF/AFOyFG+vaWo2MYwTHDYQjx4W1Wrz3EauzEBjxSOJj6VNL181+aQkRJI59ERY+SGsic3LES01bif+uruSa3qaobWJqHPKlR904q5UZlNCjS0Vqq4indZVqnNTWFD5C1EBavmwikO5SuDiprSmtT5oCy3SpeJHuOon0B6XApfn8kxVXs2WFq9iar4aZ+aitKScWkSVntp7iemIzLmzpR4lsRudbTILPKl5Y8ewzTCwmm0j2iSbmdf+6WVpBESSOeQFBTlHR1xqTQ27rJQbO0tosObUs///nVlH79sNNDTsJHyZv8iSqRYAT7r0JYJwOD3lFwIZjr4Ub3kQ4HS6tXVvTis3VYIDVfeK0nL3O9MTwnlp7Yu2htUfrZmrxed2+mP5g7b21T9aO8t+vwG/mOf4yG0isQwAAAABJRU5ErkJggg==");
  cursor: pointer;
}
</style>
